import axios from "axios";
import transformData from "./transformData";
import { retryFetch } from "./helpers";

const REQUEST_URI = process.env.REACT_APP_PA_API;

const scan = async (eventID, qrCodeID) => {
  const url = `${REQUEST_URI}/scan/${qrCodeID}?eventID=${eventID}`;

  return await axios(url, {
    headers: { 'Content-Type': 'application/json' }
  })
    .then(res => res.data)
    .catch(err => err.response.data);
};

const getMember = async (payload) => {
  return await retryFetch({
    method: 'POST',
    url: `${REQUEST_URI}/member`,
    data: payload
  }, 2);
};

const submitData = async data => {
  data = transformData(data);
  return await retryFetch({
    method: 'POST',
    url: `${REQUEST_URI}/submit`,
    data
  }, 2);
};

const getBanners = async () => {
  return await retryFetch({
    method: 'GET',
    url: `${REQUEST_URI}/announcements`
  })
}

export { getMember, scan, submitData, getBanners }